// extracted by mini-css-extract-plugin
export default {"ribbonContainer":"ribbon-navigation_ribbonContainer__RWVNJ","printRibbonContainer":"ribbon-navigation_printRibbonContainer__a7KsP"};